interface Prop {
  title: string;
  children?: React.ReactNode;
  testId?:string
}

export const SIMPLTitle = ({ title, children,testId }: Prop) => {
  return (
    <div className="w-full flex flex-col gap-6"> 
      {/* Title */}
      <span className="font-['Arial'] text-[28px] font-bold leading-[44px] text-left text-Foundation/Heading"
       data-test-id={testId}>
        {title}
      </span>
      <div className="w-full">
        {children}
      </div>
    </div>
  );
};
